import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { venueService } from '@/services';

const VENUES_QUERY_KEY = ['venues'] as const;

export function useVenues() {
  const queryClient = useQueryClient();

  const { data: venues = [], isLoading } = useQuery({
    queryKey: VENUES_QUERY_KEY,
    queryFn: venueService.getVenues,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    const unsubscribe = venueService.subscribeToVenues(updatedVenues => {
      queryClient.setQueryData(VENUES_QUERY_KEY, updatedVenues);
    });
    return () => unsubscribe();
  }, [queryClient]);

  return { venues, isLoading };
}
